import Path from "./Path";
import StatusValidation from "./StatusValidation";
import Cookies from "js-cookie";

export function PostData(pathValue, type, userData, formData = false, token = true) {
	return new Promise((resolve, reject) => {
		let header = {};
		if (token) {
			header["Authorization"] = "Bearer " + Cookies.get("_cb_admin_token");
		}
		if (!formData) {
			header["Content-Type"] = "application/json";
		}
		fetch(Path(pathValue) + type, {
			method: "POST",
			body: formData ? userData : JSON.stringify(userData),
			headers: header,
		}).then((response) => StatusValidation(response))
		.then((responseJson) => {
			resolve(responseJson);
		}).catch((error) => {
			console.log(error);
			reject(error);
		});
	});
}

export function DownloadData(pathValue, type, userData, formData = false, token = true) {
	return new Promise(async (resolve, reject) => {
	  try {
		 let header = {};
		 if (token) {
			header["Authorization"] = "Bearer " + Cookies.get("_cb_admin_token");
		 }
		 if (!formData) {
			header["Content-Type"] = "application/json";
		 }
 
		 const response = await fetch(Path(pathValue) + type, {
			method: "POST",
			body: formData ? userData : JSON.stringify(userData),
			headers: header,
		 });
 
		 if (!response.ok) {
			const errorText = await response.text();
			throw new Error(errorText || "Request failed");
		 }
 
		 const contentType = response.headers.get("content-type");
		 let data;
 
		 if (contentType && contentType.includes("application/json")) {
			data = await response.json();
		 } else {
			data = await response.text();
		 }
 
		 resolve(data);
	  } catch (error) {
		 console.error(error);
		 reject(error);
	  }
	});
 }

/** POST that expects a binary file (e.g. XLSX). Returns { blob, filename }. */
export function DownloadBlob(pathValue, type, userData, token = true) {
	return new Promise(async (resolve, reject) => {
		try {
			const header = {};
			if (token) {
				header["Authorization"] = "Bearer " + Cookies.get("_cb_admin_token")
			}
			header["Content-Type"] = "application/json";

			const response = await fetch(Path(pathValue) + type, {
				method: "POST",
				body: JSON.stringify(userData),
				headers: header,
			});

			const contentType = response.headers.get("content-type") || "";
			if (!response.ok) {
				let message = "Download failed";
				try {
					if (contentType.includes("application/json")) {
						const json = await response.json();
						message =
							json?.message?.message || json?.message || message;
					} else {
						message = (await response.text()) || message;
					}
				} catch {
					/* ignore parse errors */
				}
				throw new Error(message);
			}

			const disposition = response.headers.get("content-disposition") || "";
			const filenameMatch = disposition.match(
				/filename\*?=(?:UTF-8''|")?([^\";]+)"?/i
			);
			const filename = filenameMatch
				? decodeURIComponent(filenameMatch[1].replace(/"/g, ""))
				: "download.xlsx";

			const blob = await response.blob();
			resolve({ blob, filename });
		} catch (error) {
			console.error(error);
			reject(error);
		}
	});
}

export function GetData(pathValue, type, userData) {
	return new Promise((resolve, reject) => {
		fetch(Path(pathValue) + type, {
			method: "Get",
			body: JSON.stringify(userData),
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + Cookies.get("_cb_admin_token")
			},
		}).then((response) => StatusValidation(response))
		.then((responseJson) => {
			resolve(responseJson);
		}).catch((error) => {
			reject(error);
		});
	});
  }

export const PutData = ( pathValue, type, userData, formData = false, token = true ) => {
	return new Promise((resolve, reject) => {
		let header = {};
		const authToken = Cookies.get("_cb_admin_token");
		if (authToken && token) {
			header["Authorization"] = "Bearer " + authToken;
		}
		if (!formData) {
			header["Content-Type"] = "application/json";
		}
		fetch(Path(pathValue) + type, {
			method: "PUT",
			body: formData ? userData : JSON.stringify(userData),
			headers: header,
		}).then((response) => {
			return response.json();
		}).then((responseJson) => {
			resolve(responseJson);
		}).catch((error) => {
			console.error("Error:", error);
			reject(error);
		});
	});
};

export function DeleteData( pathValue, type, userData, formData = false, token = true ) {
	return new Promise((resolve, reject) => {
		let header = {};
		if (token) {
			header["Authorization"] = "Bearer " + Cookies.get("_cb_admin_token");
		}
		if (!formData) {
			header["Content-Type"] = "application/json";
		}
		fetch(Path(pathValue) + type, {
			method: "DELETE",
			body: formData ? userData : JSON.stringify(userData),
			headers: header,
		}).then((response) => StatusValidation(response))
		.then((responseJson) => {
			resolve(responseJson);
		}).catch((error) => {
			console.log(error);
			reject(error);
		});
	});
}

export function PostDataWithApiKey(pathValue, type, userData, apiKey) {
	return new Promise((resolve, reject) => {
		let header = {
			"Content-Type": "application/json",
			"cb-api-key": apiKey
		};
		fetch(Path(pathValue) + type, {
			method: "POST",
			body: JSON.stringify(userData),
			headers: header,
		}).then((response) => StatusValidation(response))
		.then((responseJson) => {
			resolve(responseJson);
		}).catch((error) => {
			console.log(error);
			reject(error);
		});
	});
}
